<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="accountNum" >
        <el-select v-model="queryParams.accountNum" filterable placeholder="收款账号" @change="search" clearable>
          <el-option v-for="item in operator" :key="item.accountNum" :label="item.name" :value="item.accountNum"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="dateKey">
        <el-select v-model="queryParams.dateKey" filterable placeholder="选择时间筛选方式" @change="selectSearch()" clearable>
          <el-option v-for="item in timeArr" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          :picker-options="pickerOptions"
            v-if="searchTimeShow"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            v-model="searchTime"
            @change="search"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-date-picker
            :picker-options="pickerOptions"
            value-format="yyyy-MM"
            v-if="monthShow"
            style="width:210px"
            v-model="queryParams.month"
            type="month"
            @change="search"
            placeholder="选择月">
          </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-date-picker
            :picker-options="pickerOptions"
            value-format="yyyy"
            v-if="yearShow"
            style="width:210px"
            v-model="queryParams.year"
            type="year"
            @change="search"
            placeholder="选择年">
          </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- 内容部分 -->
    <div class="content-class">
      <div class="xsClsaa">
        <el-popover placement="bottom" width="260" trigger="click">
          <el-button size="small" icon="el-icon-s-operation" slot="reference">自定义显示列</el-button>
          <ul class="ulclass">
            <li v-for="(item,index) in xsData" :key="index" class="sjClass">
              <span>{{item.columnName}}</span>
              <el-switch
                v-model="item.show"
                active-color="#409EFF"
                inactive-color="#DCDFE6"
                active-value="1"
                inactive-value="0"
                :disabled = "item.dis"
                @change="alonerenewChange(item,$event)"
              ></el-switch>
            </li>
          </ul>
        </el-popover>
      </div>
      <div>
        <el-table :data="tableData" border>
          <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
          <el-table-column align="center" v-for="(item,index) in topArry" :key="index" :prop="item.columnKey" :label="item.columnName" min-width="175px"></el-table-column>
        </el-table>
      </div>
      <div class="block" style="margin-top: 30px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { sysTable } from "@/api/api.js"; 
import { userAccount } from "@/api/api.js";
import { tableUpdateUserTable } from "@/api/api.js";
import { accountInfos } from "@/api/api.js";
export default {
  data() {
    return{
      // 未到的日期不可选择
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now(); 
        }
      },
      sjClassShow:false,
      queryParams:{},
      tableData:[],
      topArry:[],
      xsData:[],
      page: 1,
      pageSize: 20,
      total:0,
      an:false,
      searchTime:[],
      operator:[],
      timeArr:[
        { value: 1, label: "年" },
        { value: 2, label: "月" },
        { value: 3, label: "范围" },
      ],
      searchTimeShow:false,
      yearShow:false,
      monthShow:false,
    }
  },
  methods: {
    // 自定义显示表头数据
    alonerenewChange(item,val){
      let params = {
        tableId:item.id,
        show:val
      }
      tableUpdateUserTable(params).then(res =>{
        if (res.data.code == 200) {
          this.initData()
        }
      });
    },
    hidden(){
      this.an = this.an == false ? true : false
    },
    // 按年月日筛选
    selectSearch(){
      this.an = true;
      if(this.queryParams.dateKey == "1"){
        this.yearShow = true;
        this.monthShow = false;
        this.searchTimeShow = false;
        this.$set(this.queryParams,"month","");
        this.searchTime = [];
      }else if(this.queryParams.dateKey == "2"){
        this.monthShow = true;
        this.yearShow = false;
        this.searchTimeShow = false;
        this.$set(this.queryParams,"year","");
        this.searchTime = [];
      }else{
        this.searchTimeShow = true;
        this.yearShow = false;
        this.monthShow = false;
        this.$set(this.queryParams,"month","");
        this.$set(this.queryParams,"year","");
      }
    },
    // 获取列表的数据
    initData(){
      let params = {
        model: {
          ...this.addDateRange(this.queryParams, this.searchTime),
        },
        page: this.page,
        pageSize: this.pageSize
      };
      userAccount(params).then(res =>{
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
          this.tableData.map((item,index) => {
            item.ids = index + 1;
          })
        }
      });
      sysTable({moduleName:"account_pay_list",show: "1"}).then(res =>{
        if (res.data.code == 200) {
          this.topArry = res.data.data;
        }
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.searchTime = [];
      this.resetForm("queryForm");
      this.initData();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
  },
  created() {
    
  },
  mounted() {
    this.initData();
    sysTable({moduleName:"account_pay_list",show: ""}).then(res =>{
      this.xsData = res.data.data;
    });
    accountInfos().then(res =>{
      this.operator = res.data.data;
    })
  },
};
</script>

<style scoped lang="less">
.cell button{
  width: 50px;
  font-size: 12px;
  text-align: center;
  padding: 6px;
}
.demo-table-expand{
  display: flex;
  flex-wrap:wrap
}
.demo-table-expand .el-form-item {
  margin-bottom: 10px;
  width: 50%;
}
.searchOne{
  display: inline-block;
  .el-input{
    margin-right: 30px;
    width:210px;
  }
  .el-select{
    margin-right: 30px;
    width:210px;
  }
  .el-date-editor{
    width:450px ;
  }
}
.rotating {
  transform: rotate(90deg);
}
.el-button--small.icon-button-auto {
  padding: 12px 9px;
  position: relative;
  top: -1px;
}
.span-but{
  margin-left: -30px;
  button{
    padding: 10px 20px;
    margin-top: 3px;
    margin-left: 5px;
  }
}
.array-class{
  width: 70%;
  display: flex;
  flex-wrap:wrap;
  margin-top: 5px;
  .el-input{
    margin-right: 30px;
    width:210px;
    margin-top: 15px;
  }
  .el-select{
    margin-right: 30px;
    width:210px;
    margin-top: 15px;
  }
  .el-date-editor{
    width:450px ;
    margin-top: 15px;
    margin-right: 30px;
  }
}
.xsClsaa{
  margin: 5px;
  display: flex;
  justify-content: right;
}
.ulclass{
  height: 260px;
  overflow-y: scroll;
}
.sjClass{
  margin: 15px 0;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
}
</style>


